import React from 'react';
import { withTranslation } from "react-i18next";
import CaAccountModalView from "./CaAccountModalView";

const CaAccountDeleteAccountContainer = props => {

    const newProps = Object.assign({},{
        title:"Delete account",
        body:"Delete account",
        submitCta:"Delete",
        formFieldsData: [
            {
                type:'password',
                validateAs:'password',
                placeholder:props.t('account_modal.placeholders.password'),
                id:"delete_password"
            }
        ],
        "title": props.t('account_modal.delete_account.title'),
        "body": props.t('account_modal.delete_account.body'),
        "submitCta": props.t('account_modal.delete_account.submitCta'),
        "success_message": props.t('account_modal.delete_account.success_message'),
    });

    return (
        <CaAccountModalView
            {...Object.assign({},props,newProps)}
        />
    )
}
export default withTranslation("translations")(CaAccountDeleteAccountContainer);